import {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";

import _ from "lodash";
import {app, onair} from "../../../modules/config.ts";
import {Api} from "../../../modules/api.ts";
import type {ScrollGradientCleanup} from "../../../modules/interfaces.ts";
import type {DaoCategory} from "../../../daos/dao-category.ts";
import type {DaoChannel} from "../../../daos/dao-channel.ts";
import type {DaoMedia} from "../../../daos/dao-media.ts";
import Category from "../../component/category.tsx";
import Channel from "../../component/channel.tsx";
import {useAppDispatch} from "../../../stores/hook.ts";
import {askConfirm} from "../../../stores/dialog.thunk.ts";
import {openModalBottom} from "../../../stores/modal.bottom.slice.ts";
import {store} from "../../../stores";


function PageChannel() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [category, setCategory] = useState<DaoCategory | null>(null);
  const [channels, setChannels] = useState<DaoChannel[]>([]);
  // 채널 사용여부
  const [channelUse, setChannelUse] = useState<boolean>(app.user?.channel === "1");

  useEffect(() => {
    setChannelUse(app.user?.channel === "1");
    setChannels([]);
    const params = new URLSearchParams(location.search);
    const no = params.get('category') ?? "-1";
    let matchCategory: DaoCategory | null = null;
    if(_.isEqual(no, "-1")) {
      matchCategory = {no: '-1', name: '즐겨찾는 채널'} as DaoCategory;
    } else {
      if(channelUse) {
        for(let i = 0; i < app.categories.length; i++) {
          const _category: DaoCategory = app.categories[i];
          if(_.isEqual(Number(_category.no), Number(no))) {
            matchCategory = _category;
            break;
          }
        }
      }
    }

    (async () => {
      if(matchCategory) {
        setCategory(matchCategory);

        const rs = await Api.channel(matchCategory.no!);
        const daoChannels: DaoChannel[] = (rs?.data?.ITEMS ?? []).map((channel: DaoChannel) => (
          {
            ...channel,
            favorite: Number(channel.favorite),
            counts: Number(channel.counts),
            duration: Number(channel.duration),
          } as DaoChannel
        ));
        setChannels(daoChannels);
      }
    })();

    const cleanups = initScrollGradients('.category-scroll', '.category-scroll-inner');
    // const modalToggle = setupModalToggle('myModal', '.category-toggle');
    return () => {
      cleanups.forEach(fn => fn());
      // modalToggle();
    };
  }, [location]);

  async function openCategory() {
    store.dispatch(openModalBottom({ type: 'category', data: category }));
    // await dispatch(askModalBottom('category', category))
  }

  /**
   * 그라데이션
   * @param wrapperSelector
   * @param scrollSelector
   */
  function initScrollGradients(wrapperSelector: string, scrollSelector: string | null = null): ScrollGradientCleanup[] {
    const wrappers = document.querySelectorAll<HTMLElement>(wrapperSelector);
    const cleanupFunctions: ScrollGradientCleanup[] = [];

    wrappers.forEach(wrapper => {
      const scrollTarget = scrollSelector
        ? wrapper.querySelector<HTMLElement>(scrollSelector)
        : wrapper;

      if (!scrollTarget) return;



      const updateGradient = () => {
        const topGrad = wrapper.querySelector<HTMLElement>('.scroll-gradient-top');
        const botGrad = wrapper.querySelector<HTMLElement>('.scroll-gradient-bottom');

        const { scrollTop, scrollHeight, clientHeight } = scrollTarget;

        if (topGrad) {
          topGrad.style.opacity = scrollTop > 1 ? '1' : '0';
        }

        if (botGrad) {
          botGrad.style.opacity =
            scrollTop + clientHeight < scrollHeight - 1 ? '1' : '0';
        }
      };

      scrollTarget.addEventListener('scroll', updateGradient);
      updateGradient();

      cleanupFunctions.push(() => {
        scrollTarget.removeEventListener('scroll', updateGradient);
      });
    });

    return cleanupFunctions;
  }

  // function setupModalToggle(modalId: string, toggleSelector: string): DestroyFn {
  //   const scroller = document.querySelector<HTMLDivElement>(".scroll-area");
  //   const modal = document.getElementById(modalId) as HTMLElement | null;
  //   const toggleButtons = document.querySelector<HTMLButtonElement | HTMLAnchorElement>(toggleSelector);
  //
  //   if (!modal || !toggleButtons) {
  //     return () => {};
  //   }
  //
  //   const onToggleClick = (e: Event) => {
  //     e.preventDefault();
  //     modal.style.display = 'block';
  //     if(scroller) scroller.style.zIndex = String(20);
  //   };
  //
  //   const onModalClick = (e: MouseEvent) => {
  //     const target = e.target as HTMLElement;
  //     if (target === modal || target.tagName.toLowerCase() === "a") {
  //       modal.style.display = 'none';
  //       if(scroller) scroller.style.zIndex = "unset";
  //     }
  //   };
  //
  //   toggleButtons.addEventListener('click', onToggleClick);
  //   modal.addEventListener('click', onModalClick);
  //
  //   return () => {
  //     toggleButtons.removeEventListener('click', onToggleClick);
  //     modal.removeEventListener('click', onModalClick);
  //   };
  // }

  /**
   *
   * @param daoChannel
   */
  async function listenHandler(daoChannel: DaoChannel): Promise<void> {
    await onair.channel(daoChannel.no);
  }

  /**
   *
   */
  function favoriteHandler(): void {
    if(_.isEqual(category?.no, "-1")) {
      navigate(location.pathname);
    }
  }

  /**
   * 전용방송 클릭
   */
  async function exclusiveChannelHandler() {
    const media: DaoMedia | null = onair.media;
    if(media != null) {
      if(media.type !== "GN") {
        if(onair.isClearable(media.type)) {
          let isConfirm: boolean;
          if(onair.isAdvertise(media.type)) {
            isConfirm = await dispatch(askConfirm('', `"${onair.getPriorityName(media.type)}" 재생중입니다. 재생을 중지하시겠습니까?`));
            if(isConfirm) onair.restore();
            return;
          } else {
            isConfirm = await dispatch(askConfirm('', '전용방송을 재생하시겠습니까?'));
            if(isConfirm) onair.restore();
          }
        }
      }
    }
  }

  return (
    <main>
      <section className="contents">
        <div className="category">
          <div className="category-fixed">
            <a onClick={exclusiveChannelHandler}>전용방송 <span><img alt="" src="/images/icon-arrow.png"/></span></a>
          </div>
          <div className="category-scroll">
            <div className="scroll-gradient-top"></div>
            <div className="scroll-gradient-bottom"></div>
            <div className="category-scroll-inner">
              {channelUse && <div className="category-list mobile-category" onClick={openCategory}>
                <span className="category-toggle"><a>{!_.isEqual(category?.no, '-1') ? category?.name : "카테고리선택"} <img alt="" src="/images/icon-drop.png"/></a></span>
              </div>}

              {channelUse && <div className="category-list">
                <div className="category-item"><Link to="/main" className={`${_.isEqual(category?.no, "-1") ? 'on' : ''}`}>즐겨찾는 채널</Link></div>
              </div>}


              {channelUse && <Category current={category} classname="tablet-category" />}
            </div>
          </div>
        </div>
        <div className="channel-list">
          <div className="scroll-gradient-top"></div>
          <div className="scroll-gradient-bottom"></div>
          <div className="channel-list-inner">
            {
              channels.length < 1 ?

                <article className="channel-item">
                  {channelUse ? `"${category?.name}" 검색된 채널이 없습니다.` : '채널을 사용할수 없습니다.'}
                </article> :

                channels.map((channel: DaoChannel, idx: number) => (
                  <Channel channel={channel} listenCallback={listenHandler} favoriteCallback={favoriteHandler} key={idx} />
                ))
            }
          </div>
        </div>
      </section>
    </main>
  );
}

export default PageChannel;